module.exports = __webpack_public_path__ + "img/Update.fed908a4.png";